<template>
    <div class="settings">
            <div class="settings__settings">
                <div class="settings__setting">
                  <p class="settings__title">Доступ</p>
                  <VSegmentedControl
                      class="settings__tabs"
                      :items="blockedOptions"
                      :modelValue="has_contract"
                      :key="has_contract"
                      @update:modelValue="updateBlocked"
                  />
                </div>
            </div>
    </div>
</template>

<script setup>
import {ref, computed, onMounted, watch} from 'vue'

const props = defineProps({
  modelValue: {
      type: Object,
      required: true
  },
  admin: Boolean,
});

const emit = defineEmits(["update:modelValue"]);
const blockedOptions = [
  {
    id: 'active',
    label: "Активно",
  },
  {
    id: 'blocked',
    label: "Заблокировано",
  },
];
const has_contract = ref('active');

const updateBlocked = (id) => {
  has_contract.value = id
  form.value.has_contract = id === 'active' ? true : false
}

const form = computed({
    get: () => props.modelValue,
    set: (value) => emit("update:modelValue", value),
});

watch(() => props.modelValue, (newValue) => {
  has_contract.value = props.modelValue?.has_contract ? 'active' : 'blocked';
}, {deep: true});

onMounted(() => {
  has_contract.value = props.modelValue?.has_contract ? 'active' : 'blocked';
})
</script>

<style scoped lang="scss">
.settings {
    width: 100%;
    padding: 24px;
    border-radius: 16px;
    background-color: #fff;
    box-shadow: 2px 2px 8px 0px #0000000A;


    &__title {
        font-size: 20px;
        font-weight: 500;
    }

    &__content {
        margin-top: 16px;
    }

    &__setting {
        width: 100%;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &:not(:first-child) {
            margin-top: 16px;
        }
    }

    &__setting-label {
        color: $dark;
        font-size: 14px;
        font-weight: 400;
    }

    &__tabs {
      width: 324px;
      height: 40px;
    }

    &__row {
        margin-bottom: 16px;
        display: flex;
        justify-content: space-between;
    }

    &__row &__checkbox-label {
        width: 49%;
    }

    &__checkbox-label {
        width: 100%;
    }
}
</style>
